<template>
  <div>
    <el-card>
      <el-row>
        <el-col>
          <el-date-picker
            v-model="starttime"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>

          <el-button
            type="goon"
            style="margin-left: 20px"
            @click="GetEscalationEstimatePeopleList"
            >查询</el-button
          >
        </el-col>
      </el-row>
    </el-card>
    <el-card style="margin-top: 20px">
      <el-button type="goon" style="margin-right: 35px" @click="onClickAdd"
        >上传预估人数</el-button
      >
    </el-card>
    <el-card style="margin-top: 20px">
      <el-table
        :data="tableData"
        style="width: 100%"
        :header-cell-style="{
          background: '#F2F5FF',
          color: '#333',
          'text-align': 'center',
        }"
        border
      >
        <el-table-column label="序号" width="60" align="center">
          <template slot-scope="scope">
            {{ scope.$index + (PageIndex - 1) * PageSize + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="ModifyBy" label="修改人" align="center">
        </el-table-column>
        <el-table-column
          prop="ShowDate"
          label="开始时间"
          align="center"
          width="100"
        >
        </el-table-column>
        <el-table-column prop="Time" label="时间" align="center">
        </el-table-column>
        <el-table-column prop="UpdateTime" label="最后修改时间" align="center">
        </el-table-column>
        <el-table-column
          prop="littleOneWeekDayNum"
          label="托小周一"
          align="center"
          width="50"
        >
        </el-table-column>
        <el-table-column
          prop="littleTwoWeekDayNum"
          label="托小周二"
          align="center"
          width="50"
        >
        </el-table-column>
        <el-table-column
          prop="littleThreeWeekDayNum"
          label="托小周三"
          align="center"
          width="50"
        >
        </el-table-column>
        <el-table-column
          prop="littleFourWeekDayNum"
          label="托小周四"
          align="center"
          width="50"
        >
        </el-table-column>
        <el-table-column
          prop="littleFiveWeekDayNum"
          label="托小周五"
          align="center"
          width="50"
        >
        </el-table-column>

        <el-table-column
          prop="inOneWeekDayNum"
          label="中班周一"
          align="center"
          width="50"
        >
        </el-table-column>
        <el-table-column
          prop="inTwoWeekDayNum"
          label="中班周二"
          align="center"
          width="50"
        >
        </el-table-column>
        <el-table-column
          prop="inThreeWeekDayNum"
          label="中班周三"
          align="center"
          width="50"
        >
        </el-table-column>
        <el-table-column
          prop="inFourWeekDayNum"
          label="中班周四"
          align="center"
          width="50"
        >
        </el-table-column>
        <el-table-column
          prop="inFiveWeekDayNum"
          label="中班周五"
          align="center"
          width="50"
        >
        </el-table-column>
        <el-table-column
          prop="bigOneWeekDayNum"
          label="大班周一"
          align="center"
          width="50"
        >
        </el-table-column>
        <el-table-column
          prop="bigTwoWeekDayNum"
          label="大班周二"
          align="center"
          width="50"
        >
        </el-table-column>
        <el-table-column
          prop="bigThreeWeekDayNum"
          label="大班周三"
          align="center"
          width="50"
        >
        </el-table-column>
        <el-table-column
          prop="bigFourWeekDayNum"
          label="大班周四"
          align="center"
          width="50"
        >
        </el-table-column>
        <el-table-column
          prop="bigFiveWeekDayNum"
          label="大班周五"
          align="center"
          width="50"
        >
        </el-table-column>
        <el-table-column label="操作" align="center" width="55">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.IsUpdate"
              type="text"
              style="color: #4083fe"
              @click="onEditRow(scope.row)"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="PageIndex"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="PageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="text-align: center;padding:20px; 0 0 0"
      >
      </el-pagination>
    </el-card>
    <el-dialog :title="Title" :visible.sync="dialogVisible" width="50%">
      <div>
        <el-form
          :model="ruleForm"
          ref="ruleForm"
          :rules="rules"
          class="demo-ruleForm"
          label-position="top"
        >
          <el-form-item label="时间段" prop="startDate" v-if="Title == '新增'">
            <div style="font-size: 14px; color: red">*选择所需周的周一即可</div>
            <el-date-picker
              v-model="ruleForm.startDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="托班；小班" prop="littleOneWeekDayNum">
            <div class="flex-items">
              <el-input
                v-model="ruleForm.littleOneWeekDayNum"
                style="margin-right: 20px"
                type="number"
                placeholder="周一"
              ></el-input>
              <el-input
                v-model="ruleForm.littleTwoWeekDayNum"
                style="margin-right: 20px"
                type="number"
                placeholder="周二"
              ></el-input>
              <el-input
                v-model="ruleForm.littleThreeWeekDayNum"
                style="margin-right: 20px"
                type="number"
                placeholder="周三"
              ></el-input>
              <el-input
                v-model="ruleForm.littleFourWeekDayNum"
                style="margin-right: 20px"
                type="number"
                placeholder="周四"
              ></el-input>
              <el-input
                v-model="ruleForm.littleFiveWeekDayNum"
                placeholder="周五"
                type="number"
              ></el-input>
            </div>
          </el-form-item>
          <el-form-item label="中班" prop="inOneWeekDayNum">
            <div class="flex-items">
              <el-input
                v-model="ruleForm.inOneWeekDayNum"
                style="margin-right: 20px"
                placeholder="周一"
                type="number"
              ></el-input>
              <el-input
                v-model="ruleForm.inTwoWeekDayNum"
                style="margin-right: 20px"
                placeholder="周二"
                type="number"
              ></el-input>
              <el-input
                v-model="ruleForm.inThreeWeekDayNum"
                style="margin-right: 20px"
                placeholder="周三"
                type="number"
              ></el-input>
              <el-input
                v-model="ruleForm.inFourWeekDayNum"
                style="margin-right: 20px"
                placeholder="周四"
                type="number"
              ></el-input>
              <el-input
                v-model="ruleForm.inFiveWeekDayNum"
                placeholder="周五"
                type="number"
              ></el-input>
            </div>
          </el-form-item>
          <el-form-item label="大班" prop="bigOneWeekDayNum">
            <div class="flex-items">
              <el-input
                v-model="ruleForm.bigOneWeekDayNum"
                style="margin-right: 20px"
                placeholder="周一"
                type="number"
              ></el-input>
              <el-input
                v-model="ruleForm.bigTwoWeekDayNum"
                style="margin-right: 20px"
                placeholder="周二"
                type="number"
              ></el-input>
              <el-input
                v-model="ruleForm.bigThreeWeekDayNum"
                style="margin-right: 20px"
                placeholder="周三"
                type="number"
              ></el-input>
              <el-input
                v-model="ruleForm.bigFourWeekDayNum"
                style="margin-right: 20px"
                placeholder="周四"
                type="number"
              ></el-input>
              <el-input
                v-model="ruleForm.bigFiveWeekDayNum"
                placeholder="周五"
                type="number"
              ></el-input>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="
            Title == '新增' ? addSubmit('ruleForm') : editSubmit('ruleForm')
          "
          >提 交</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
  <script>
import {
  GetEscalationEstimatePeopleList,
  EscalationEstimatePeople,
  GetHe_FoodPersonDetailList,
  UpdateHe_FoodPerson,
  DelHe_FoodPerson,
  GetClassDetailInfoList,
} from "../../../api/api";
import {
  getWeekStartDate,
  getWeekEndDateFive,
} from "../../../../util/otherRenders";

import moment from "moment";

export default {
  data() {
    return {
      starttime: [],
      tableData: [],
      addTableData: [],
      PageSize: 10,
      PageIndex: 1,
      total: 0,
      dialogVisible: false,
      Title: "",
      ruleForm: {
        Id: 0,
        startDate: "",
        littleOneWeekDayNum: null,
        littleTwoWeekDayNum: null,
        littleThreeWeekDayNum: null,
        littleFourWeekDayNum: null,
        littleFiveWeekDayNum: null,
        bigOneWeekDayNum: null,
        bigTwoWeekDayNum: null,
        bigThreeWeekDayNum: null,
        bigFourWeekDayNum: null,
        bigFiveWeekDayNum: null,
        inOneWeekDayNum: null,
        inTwoWeekDayNum: null,
        inThreeWeekDayNum: null,
        inFourWeekDayNum: null,
        inFiveWeekDayNum: null,
      },
      userInfo: {},
      Reporter: "",
      SchoolId: 0,
      Id: 0,
      value1: "",
      rules: {
        startDate: [
          { required: true, message: "请选择时间段", trigger: "change" },
        ],
        littleOneWeekDayNum: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        bigOneWeekDayNum: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        inOneWeekDayNum: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
      },
    };
  },
  async created() {
    this.userInfo = JSON.parse(window.localStorage.user);
    this.getNexWeek();
    await this.GetEscalationEstimatePeopleList();
  },
  computed: {},
  methods: {
    getNexWeek: function (nexday) {
      let data = new Date();
      // 年
      let year = new Date().getFullYear();
      // 月
      let month = new Date().getMonth() + 1;
      let day = new Date().getDate();

      this.ruleForm.startDate = year + "-" + month + "-" + day;
    },
    resetData() {
      this.ruleForm = {
        Id: 0,
        startDate: "",
        littleOneWeekDayNum: null,
        littleTwoWeekDayNum: null,
        littleThreeWeekDayNum: null,
        littleFourWeekDayNum: null,
        littleFiveWeekDayNum: null,
        bigOneWeekDayNum: null,
        bigTwoWeekDayNum: null,
        bigThreeWeekDayNum: null,
        bigFourWeekDayNum: null,
        bigFiveWeekDayNum: null,
        inFiveWeekDayNum: null,
        inFourWeekDayNum: null,
        inOneWeekDayNum: null,
        inThreeWeekDayNum: null,
        inTwoWeekDayNum: null,
      };
    },
    // 删除
    async onClickDelete(item) {
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        let res = await DelHe_FoodPerson({ ids: [item.Id] });
        if (res.data.success) {
          this.$message({
            type: "success",
            message: "删除成功!",
          });
          this.GetEscalationEstimatePeopleList();
        } else {
          this.$message({
            type: "error",
            message: "删除失败!",
          });
        }
      });
    },
    // 编辑
    async onEditRow(row) {
      this.Title = "编辑";
      console.log(row);
      this.ruleForm = row;
      this.dialogVisible = true;
    },
    // 编辑确定
    async editSubmit(formName) {
      const params = {
        Id: this.ruleForm.Id,
        littleOneWeekDayNum: this.ruleForm.littleOneWeekDayNum,
        littleTwoWeekDayNum: this.ruleForm.littleTwoWeekDayNum,
        littleThreeWeekDayNum: this.ruleForm.littleThreeWeekDayNum,
        littleFourWeekDayNum: this.ruleForm.littleFourWeekDayNum,
        littleFiveWeekDayNum: this.ruleForm.littleFiveWeekDayNum,
        bigOneWeekDayNum: this.ruleForm.bigOneWeekDayNum,
        bigTwoWeekDayNum: this.ruleForm.bigTwoWeekDayNum,
        bigThreeWeekDayNum: this.ruleForm.bigThreeWeekDayNum,
        bigFourWeekDayNum: this.ruleForm.bigFourWeekDayNum,
        bigFiveWeekDayNum: this.ruleForm.bigFiveWeekDayNum,
        inFiveWeekDayNum: this.ruleForm.inFiveWeekDayNum,
        inFourWeekDayNum: this.ruleForm.inFourWeekDayNum,
        inOneWeekDayNum: this.ruleForm.inOneWeekDayNum,
        inThreeWeekDayNum: this.ruleForm.inThreeWeekDayNum,
        inTwoWeekDayNum: this.ruleForm.inTwoWeekDayNum,
      };
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let res = await EscalationEstimatePeople(params);
          if (res.data.success) {
            this.$message({
              type: "success",
              message: res.data.msg,
            });
            this.dialogVisible = false;
            this.$refs[formName].resetFields(); // 重置表单移除校验
            await this.GetEscalationEstimatePeopleList();
            this.resetData();
          } else {
            this.$message({
              type: "error",
              message: "提交失败或选项未填写完毕",
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 新增
    async addSubmit(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let res = await EscalationEstimatePeople(this.ruleForm);
          if (res.data.success) {
            this.$message({
              type: "success",
              message: res.data.msg,
            });
            this.dialogVisible = false;
            this.$refs[formName].resetFields(); // 重置表单移除校验
            await this.GetEscalationEstimatePeopleList();
            this.resetData();
          } else {
            this.$message({
              type: "error",
              message: res.data.msg,
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    async GetEscalationEstimatePeopleList() {
      const params = {
        StartDate: this.starttime.length != 0 ? this.starttime[0] : "",
        EndDate: this.starttime.length != 0 ? this.starttime[1] : "",
        PageIndex: this.PageIndex,
        PageSize: this.PageSize,
      };
      let res = await GetEscalationEstimatePeopleList(params);
      if (res.data.success) {
        this.tableData = res.data.response.data;
        this.total = res.data.response.dataCount;
        //console.log(this.tableData, "asdas");
      } else {
        this.tableData = [];
        this.total = 0;
      }
    },
    async getNowTime() {
      this.starttime.push(getWeekStartDate());
      this.starttime.push(getWeekEndDateFive());
    },
    // addGetNowTime() {
    //   var now = new Date();
    //   var year = now.getFullYear(); //得到年份
    //   var month = now.getMonth(); //得到月份
    //   var date = now.getDate(); //得到日期
    //   month = month + 1;
    //   month = month.toString().padStart(2, "0");
    //   date = date.toString().padStart(2, "0");
    //   var defaultDate = `${year}-${month}-${date}`;
    //   this.$set(this.ruleForm, "date", defaultDate);
    // },
    handleCurrentChange(val) {
      this.PageIndex = val;
      this.GetEscalationEstimatePeopleList();
    },
    handleSizeChange(val) {
      this.PageSize = val;
      this.GetEscalationEstimatePeopleList();
    },
    async onClickAdd() {
      this.Title = "新增";
      this.GetClassDetailInfoList();
      this.dialogVisible = true;
    },
    sum(arr) {
      var s = 0;
      arr.forEach(function (val, idx, arr) {
        s += val.Number;
      }, 0);

      return s;
    },
    async GetClassDetailInfoList() {
      let res = await GetClassDetailInfoList({
        SchoolId: this.userInfo.SchoolId,
      });
      if (res.data.success) {
        let NewArr = res.data.response.filter(
          (item) => item.Name.includes("托") || item.Name.includes("小")
        );
        let NewArrTwo = res.data.response.filter((item) =>
          item.Name.includes("中")
        );
        let NewArrThree = res.data.response.filter((item) =>
          item.Name.includes("大")
        );
        console.log(NewArr);
        let Arr = [
          {
            Name: "托班；小班",
            Num: this.sum(NewArr),
          },
          {
            Name: "中班",
            Num: this.sum(NewArrTwo),
          },
          {
            Name: "大班",
            Num: this.sum(NewArrThree),
          },
        ];

        this.ruleForm = {
          Id: 0,
          startDate: "",
          littleOneWeekDayNum: Arr[0].Num,
          littleTwoWeekDayNum: Arr[0].Num,
          littleThreeWeekDayNum: Arr[0].Num,
          littleFourWeekDayNum: Arr[0].Num,
          littleFiveWeekDayNum: Arr[0].Num,
          bigOneWeekDayNum: Arr[2].Num,
          bigTwoWeekDayNum: Arr[2].Num,
          bigThreeWeekDayNum: Arr[2].Num,
          bigFourWeekDayNum: Arr[2].Num,
          bigFiveWeekDayNum: Arr[2].Num,
          inOneWeekDayNum: Arr[1].Num,
          inTwoWeekDayNum: Arr[1].Num,
          inThreeWeekDayNum: Arr[1].Num,
          inFourWeekDayNum: Arr[1].Num,
          inFiveWeekDayNum: Arr[1].Num,
        };
      }
    },
  },
};
</script>
  <style lang="less" scoped>
.el-button--goon {
  color: #fff;
  background-color: #5474e6;
  border-color: #5474e6;
  height: 34px;
  line-height: 34px;
  padding: 0 20px;
}
.m-r {
  margin-right: 20px;
}
</style>